import { m } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as faHeartSolid } from '@fortawesome/pro-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/pro-regular-svg-icons';

import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';

type AnimatedLikeButtonProps = {
  liked: boolean;
  isLiking: boolean;
  onClick: (event: React.MouseEvent) => void;
  size?: number;
};

export function AnimatedLikeButton({
  liked,
  isLiking,
  onClick,
  size = 18,
}: AnimatedLikeButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      disabled={isLiking}
      size="small"
      sx={{ p: 0.5, color: liked ? 'error.main' : 'text.disabled' }}
    >
      {isLiking ? (
        <CircularProgress size={size} color="inherit" />
      ) : (
        <m.span
          key={liked ? 'liked' : 'not-liked'}
          initial={liked ? { scale: 0.5 } : false}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 500, damping: 12 }}
          style={{ display: 'flex' }}
        >
          <FontAwesomeIcon
            icon={liked ? faHeartSolid : faHeartRegular}
            style={{ width: size, height: size }}
          />
        </m.span>
      )}
    </IconButton>
  );
}
